import React, { useState, useEffect } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import {
  Button,
  FormFloating,
  FormLabel,
  FormControl,
  FormText,
  Card,
} from "react-bootstrap";

const validationSchema = Yup.object().shape({
  title: Yup.string().required("Title is required"),
  keyword: Yup.string().required("Keyword is required"),
  description: Yup.string().required("Description is required"),
  specs: Yup.string().required("Specs are required"),
  audience: Yup.string().required("Audience are required"),
});

const initialValues = {
  title: "",
  audience: "",
  keyword: "",
  description: "",
  specs: "",
  asin: "",
  link: "",
  platform: "",
};

const AdvanceSearchForm = ({
  scrapedData,
  selectedPlatform,
  userID,
  handleAdvanceForm,
  loader,
  setLoader,
}) => {
  initialValues.title = scrapedData.title;
  initialValues.audience = scrapedData.audience;
  initialValues.keyword = scrapedData.keyword;
  initialValues.description = scrapedData.description;
  initialValues.specs = scrapedData.features.toString();
  initialValues.platform = selectedPlatform;

  return (
    <Card className="advanceSearchFormCard">
      <Card.Header className="font-weight-bold">Optimize Data</Card.Header>
      <Card.Body>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            setLoader(true);
            handleAdvanceForm(values);
          }}
        >
          {({ errors, touched }) => (
            <Form>
              <p>
                <label className="fw-semibold pr-2">Selected Platform:</label>
                <label className="text-capitalize">{selectedPlatform}</label>
              </p>

              <FormFloating className="mb-3">
                <Field
                  name="keyword"
                  as={FormControl}
                  placeholder="Enter keyword"
                  isInvalid={!!errors.keyword && touched.keyword}
                />
                <FormLabel>Keyword</FormLabel>
                <FormText>{errors.keyword}</FormText>
              </FormFloating>

              {selectedPlatform === "amazon" && (
                <>
                  <FormFloating className="mb-3">
                    <Field
                      name="asin"
                      as={FormControl}
                      placeholder="Enter ASIN"
                      isInvalid={!!errors.asin && touched.asin}
                    />
                    <FormLabel>ASIN</FormLabel>
                    <FormText>{errors.asin}</FormText>
                  </FormFloating>
                  <FormFloating className="mb-3">
                    <Field
                      name="link"
                      as={FormControl}
                      placeholder="Enter Link"
                      isInvalid={!!errors.link && touched.link}
                    />
                    <FormLabel>Link</FormLabel>
                    <FormText>{errors.link}</FormText>
                  </FormFloating>
                </>
              )}

              <FormFloating className="mb-3">
                <Field
                  name="title"
                  as={FormControl}
                  placeholder="Enter title"
                  isInvalid={!!errors.title && touched.title}
                />
                <FormLabel>Title</FormLabel>
                <FormText>{errors.title}</FormText>
              </FormFloating>

              <FormFloating className="mb-3">
                <Field
                  name="description"
                  as={FormControl}
                  placeholder="Enter description"
                  isInvalid={!!errors.description && touched.description}
                />
                <FormLabel>Description</FormLabel>
                <FormText>{errors.description}</FormText>
              </FormFloating>

              <FormFloating className="mb-3">
                <Field
                  name="specs"
                  as={FormControl}
                  placeholder="Enter Specs"
                  isInvalid={!!errors.specs && touched.specs}
                />
                <FormLabel>Specs</FormLabel>
                <FormText>{errors.specs}</FormText>
              </FormFloating>

              <FormFloating className="mb-3">
                <Field
                  name="audience"
                  as={FormControl}
                  placeholder="Enter audience"
                  isInvalid={!!errors.audience && touched.audience}
                />
                <FormLabel>Audience</FormLabel>
                <FormText>{errors.audience}</FormText>
              </FormFloating>

              <div className="d-flex gap-2 justify-content-center align-items-center">
                <Button variant="primary" type="submit" disabled={loader}>
                  {loader ? "Optimizing ..." : "Optimize"}
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </Card.Body>
    </Card>
  );
};

export default AdvanceSearchForm;
